"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRegisterPlatformAdministratorAccountDto = instanceOfRegisterPlatformAdministratorAccountDto;
exports.RegisterPlatformAdministratorAccountDtoFromJSON = RegisterPlatformAdministratorAccountDtoFromJSON;
exports.RegisterPlatformAdministratorAccountDtoFromJSONTyped = RegisterPlatformAdministratorAccountDtoFromJSONTyped;
exports.RegisterPlatformAdministratorAccountDtoToJSON = RegisterPlatformAdministratorAccountDtoToJSON;
exports.RegisterPlatformAdministratorAccountDtoToJSONTyped = RegisterPlatformAdministratorAccountDtoToJSONTyped;
/**
 * Check if a given object implements the RegisterPlatformAdministratorAccountDto interface.
 */
function instanceOfRegisterPlatformAdministratorAccountDto(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('auth0UserId' in value) || value['auth0UserId'] === undefined)
        return false;
    return true;
}
function RegisterPlatformAdministratorAccountDtoFromJSON(json) {
    return RegisterPlatformAdministratorAccountDtoFromJSONTyped(json, false);
}
function RegisterPlatformAdministratorAccountDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'auth0UserId': json['auth0UserId'],
    };
}
function RegisterPlatformAdministratorAccountDtoToJSON(json) {
    return RegisterPlatformAdministratorAccountDtoToJSONTyped(json, false);
}
function RegisterPlatformAdministratorAccountDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'auth0UserId': value['auth0UserId'],
    };
}
//# sourceMappingURL=RegisterPlatformAdministratorAccountDto.js.map